import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

const ensureMeta = (attr: "name" | "property", key: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
};

const ensureCanonical = () => {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  return el;
};

/**
 * 设置当前页面的 TDK（Title / Description / Keywords）与社交分享信息。
 */
export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    if (description) {
      ensureMeta("name", "description").setAttribute("content", description);
      ensureMeta("property", "og:description").setAttribute("content", description);
      ensureMeta("name", "twitter:description").setAttribute("content", description);
    }
    if (keywords) {
      ensureMeta("name", "keywords").setAttribute("content", keywords);
    }

    ensureMeta("property", "og:title").setAttribute("content", title);
    ensureMeta("name", "twitter:title").setAttribute("content", title);
    ensureMeta("property", "og:site_name").setAttribute("content", "樱花动漫网站");

    const canonical = ensureCanonical();
    const base = window.location.origin;
    const path = window.location.pathname + window.location.search;
    canonical.setAttribute("href", base + path);
  }, [title, description, keywords]);
}